import React from 'react';
import PropTypes from 'prop-types';

import { Box, Label, Paragraph, Radio } from '@zillow/constellation-10';
import { flexContainerStyles } from './styles';

const propTypes = {
  label: PropTypes.node.isRequired,
  description: PropTypes.node,
  helperText: PropTypes.node,
  name: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  checked: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
  radioExampleText: PropTypes.node,
};
const defaultProps = {
  description: null,
  helperText: null,
  checked: false,
  radioExampleText: null,
};

const RadioButton = ({
  label,
  description,
  helperText,
  checked,
  name,
  id,
  onClick,
  radioExampleText,
  tag,
  ...rest
}) => (
  <div>
    <Box
      css={{
        ...(checked
          ? {
              backgroundColor: 'bg.action.soft.default',
              border: '1px solid {colors.border.accent.brand.hero}',
            }
          : {}),
        ...flexContainerStyles,
      }}
      data-test={id}
      onClick={onClick}
      htmlFor={id}
      active={checked}
      {...rest}
    >
      {tag ? <Box css={{ marginBottom: '400' }}>{tag}</Box> : null}
      <Box css={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
        <Radio
          name={name}
          id={id}
          checked={checked}
          readOnly={true}
          data-testid={`${id}-Radio`}
          css={{ borderColor: 'border.accent.brand.hero', marginRight: '400' }}
        />
        <div>
          <Label size="lg">{label}</Label>
          <Paragraph>{description}</Paragraph>
        </div>
      </Box>
      {radioExampleText}
    </Box>
    {helperText}
  </div>
);

RadioButton.propTypes = propTypes;
RadioButton.defaultProps = defaultProps;

export default RadioButton;
